(function () {
  'use strict';

  var DISCOUNT_FACTOR = 0.75;
  var COLLECTION_PATH = '/collections/ready-to-ship';

  function discountedCents(cents) { return Math.round(Number(cents) * DISCOUNT_FACTOR); }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && typeof window.moneyFormat !== 'undefined') {
      return window.Shopify.formatMoney(cents, window.moneyFormat);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function parseDisplayedPrice(text) {
    var normalized = String(text || '').replace(/,/g, '');
    var match = normalized.match(/\d+(?:\.\d{1,2})?/);
    return match ? Math.round(parseFloat(match[0]) * 100) : null;
  }

  function isReadyToShipCollection() {
    var path = window.location.pathname.replace(/\/$/, '');
    return path === COLLECTION_PATH || path.indexOf(COLLECTION_PATH + '/') === 0;
  }

  function addSaleBadge(card) {
    var imageArea = card.querySelector('.yv-product-card-img');
    if (!imageArea || imageArea.querySelector('.rts-sale-badge')) return;
    var badge = document.createElement('div');
    badge.className = 'yv-product-badge sale-badge rts-sale-badge';
    badge.textContent = '25% OFF';
    imageArea.appendChild(badge);
  }

  function updatePriceBox(priceBox) {
    if (!priceBox || priceBox.dataset.rtsSaleApplied === 'true') return;
    var priceElement = priceBox.querySelector('.yv-product-price');
    if (!priceElement) return;
    var originalCents = parseDisplayedPrice(priceElement.textContent);
    if (originalCents === null) return;
    var varies = priceElement.classList.contains('price-varies');
    priceElement.textContent = (varies ? 'From ' : '') + formatMoney(discountedCents(originalCents));
    var compareElement = priceBox.querySelector('.yv-product-compare-price');
    if (!compareElement) {
      compareElement = document.createElement('span');
      compareElement.className = 'yv-product-compare-price';
      priceBox.appendChild(compareElement);
    }
    compareElement.textContent = formatMoney(originalCents);
    var offElement = priceBox.querySelector('.yv-product-percent-off');
    if (!offElement) {
      offElement = document.createElement('span');
      offElement.className = 'yv-product-percent-off rts-percent-off';
      priceBox.appendChild(offElement);
    }
    offElement.textContent = '25% OFF';
    priceBox.dataset.readyToShipSale = 'true';
    priceBox.dataset.rtsSaleApplied = 'true';
  }

  function updateCollectionCards(root) {
    if (!isReadyToShipCollection()) return;
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.yv-product-card').forEach(function (card) {
      updatePriceBox(card.querySelector('.yv-prizebox'));
      addSaleBadge(card);
    });
    scope.querySelectorAll('.quick-add-popup .yv-prizebox, .yv_side_drawer_wrapper .yv-prizebox').forEach(updatePriceBox);
  }

  function wrapThemePriceUpdater() {
    if (typeof window.priceUpdate !== 'function' || window.priceUpdate.rtsWrapped) return;
    var originalPriceUpdate = window.priceUpdate;
    var wrapped = function (productSection, priceContainer, variant, showSaved) {
      if (priceContainer && priceContainer.dataset.readyToShipSale === 'true' && variant) {
        var saleVariant = Object.assign({}, variant);
        var originalPrice = Number(variant.price);
        saleVariant.price = discountedCents(originalPrice);
        saleVariant.compare_at_price = originalPrice;
        return originalPriceUpdate(productSection, priceContainer, saleVariant, showSaved);
      }
      return originalPriceUpdate(productSection, priceContainer, variant, showSaved);
    };
    wrapped.rtsWrapped = true;
    window.priceUpdate = wrapped;
  }

  function injectStyles() {
    if (document.getElementById('rts-sale-display-styles')) return;
    var style = document.createElement('style');
    style.id = 'rts-sale-display-styles';
    style.textContent = [
      '.rts-sale-badge{background:#a00404!important;color:#fff!important;font-weight:700!important;}',
      '.rts-percent-off{margin-left:8px;font-weight:700;color:#a00404;}',
      '[data-ready-to-ship-sale="true"] .yv-product-price{font-weight:700;}',
      '[data-ready-to-ship-sale="true"] .yv-product-compare-price{text-decoration:line-through;opacity:.7;margin-left:8px;}',
      '.rts-countdown{max-width:1200px;margin:0 auto 28px;padding:22px 20px;background:#a00404;color:#fff;text-align:center;border-radius:10px;box-sizing:border-box;}',
      '.rts-countdown__title{font-size:clamp(22px,3vw,36px);font-weight:800;line-height:1.15;margin:0 0 8px;}',
      '.rts-countdown__sub{font-size:16px;margin:0 0 16px;}',
      '.rts-countdown__timer{display:flex;justify-content:center;gap:12px;flex-wrap:wrap;}',
      '.rts-countdown__unit{min-width:82px;background:#fff;color:#111;border-radius:8px;padding:10px 8px;}',
      '.rts-countdown__num{display:block;font-size:30px;font-weight:800;line-height:1;}',
      '.rts-countdown__label{display:block;font-size:11px;font-weight:700;letter-spacing:.08em;margin-top:5px;}',
      '@media(max-width:600px){.rts-countdown{margin-bottom:20px;padding:18px 12px}.rts-countdown__unit{min-width:65px}.rts-countdown__num{font-size:24px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function addCountdown() {
    if (!isReadyToShipCollection() || document.getElementById('rts-countdown')) return;
    var banner = document.createElement('section');
    banner.id = 'rts-countdown';
    banner.className = 'rts-countdown';
    banner.innerHTML = '<h2 class="rts-countdown__title">25% OFF READY-TO-SHIP HOODS</h2><p class="rts-countdown__sub">Sale ends in:</p><div class="rts-countdown__timer" aria-live="polite"><div class="rts-countdown__unit"><span class="rts-countdown__num" data-rts-days>00</span><span class="rts-countdown__label">DAYS</span></div><div class="rts-countdown__unit"><span class="rts-countdown__num" data-rts-hours>00</span><span class="rts-countdown__label">HOURS</span></div><div class="rts-countdown__unit"><span class="rts-countdown__num" data-rts-minutes>00</span><span class="rts-countdown__label">MINUTES</span></div><div class="rts-countdown__unit"><span class="rts-countdown__num" data-rts-seconds>00</span><span class="rts-countdown__label">SECONDS</span></div></div>';
    var main = document.getElementById('MainContent');
    if (main) main.insertBefore(banner, main.firstChild);
    var endTime = new Date('2026-08-03T20:17:00-05:00').getTime();
    var timer;
    function updateCountdown() {
      var remaining = Math.max(0, endTime - Date.now());
      var days = Math.floor(remaining / 86400000);
      var hours = Math.floor((remaining % 86400000) / 3600000);
      var minutes = Math.floor((remaining % 3600000) / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);
      banner.querySelector('[data-rts-days]').textContent = String(days).padStart(2, '0');
      banner.querySelector('[data-rts-hours]').textContent = String(hours).padStart(2, '0');
      banner.querySelector('[data-rts-minutes]').textContent = String(minutes).padStart(2, '0');
      banner.querySelector('[data-rts-seconds]').textContent = String(seconds).padStart(2, '0');
      if (remaining <= 0) {
        clearInterval(timer);
        banner.querySelector('.rts-countdown__sub').textContent = 'This sale has ended.';
      }
    }
    updateCountdown();
    timer = setInterval(updateCountdown, 1000);
  }

  function initialize() {
    injectStyles();
    wrapThemePriceUpdater();
    updateCollectionCards(document);
    addCountdown();
    var observer = new MutationObserver(function (mutations) {
      wrapThemePriceUpdater();
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) updateCollectionCards(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
